import BusinessDetailsTab from './BusinessDetailsTab'

export default BusinessDetailsTab
